<script lang="ts">
  import { getContext } from "svelte"
  import AUModal from "component_library/components/svelte/ui/AUModal.svelte"
  import type { Texts } from "website_script/types/texts"
  import type { Settings } from "website_script/types/settings"
  import { ButtonConfig } from "website_script/types/widgets"
  import { trackFunction } from "website_script/lib/tracking"
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import Svg from "./Svg.svelte"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import { getFlowsContext } from "website_script/contexts/flows"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import AUStack from "component_library/components/svelte/ui/AUStack.svelte"
  import PriceInsightsWrapper from "./PricingInsightsWrapper.svelte"

  export let car: NonNullable<Settings["car"]>

  let modal: AUModal

  const {
    close,
    conversionBox: { insights },
  } = getContext<Texts>("texts")
  const {
    pricingInsightsButtonsConfig: { buttons },
  } = getContext<Settings>("settings")
  const { triggerFlow } = getFlowsContext()

  // Currently in the ConversionBox it only makes sense to show positive price ratings
  const rating = car.au_rating == null || car.au_rating < 3 ? 0 : car.au_rating

  const _triggerFlow = (buttonConfig: ButtonConfig) => {
    modal.close()
    triggerFlow(buttonConfig, IntegrationTypes.PRICING_INSIGHTS, undefined)
    trackFunction({
      entity: "pricing-insights",
      element: "flow_button",
      action: "clicked",
      flow: buttonConfig.flow_type,
      type: "interacted_with_cta",
      carRating: rating,
    })
  }

  export function openModal() {
    trackFunction({
      entity: "pricing-insights",
      action: "displayed",
      type: "micro_proceeding",
      carRating: rating,
    })
    modal.open()
  }

  const contentButtons = buttons.filter((button) => !button.primary)
  const footerButtons = buttons.filter((button) => button.primary)
</script>

<AUModal
  bind:this={modal}
  closeLabel={close}
  showFooter={Boolean(buttons.length)}
  title={insights}
  id="conversion-box-insights-details"
  isSlim={true}
>
  <AUStack gap="lg">
    <PriceInsightsWrapper carId={car.id} />
    <AUStack gap="xs" alignItems="center" justifyContent="center">
      {#each contentButtons as button}
        <AUButton
          fullWidth
          color={button.primary ? "primary" : "secondary"}
          onClick={() => _triggerFlow(button)}
        >
          <Svg
            alt={button.text}
            aria-hidden="true"
            data={leadFlowIcon(button.icon)}
            slot="leftIcon"
          />

          {button.text}
        </AUButton>
      {/each}
    </AUStack>
  </AUStack>
  <div slot="footer">
    <AUStack gap="xs" alignItems="center" justifyContent="center">
      {#each footerButtons as button}
        <AUButton
          fullWidth
          color={button.primary ? "primary" : "secondary"}
          onClick={() => _triggerFlow(button)}
        >
          <Svg
            alt={button.text}
            aria-hidden="true"
            data={leadFlowIcon(button.icon)}
            slot="leftIcon"
          />

          {button.text}
        </AUButton>
      {/each}
    </AUStack>
  </div>
</AUModal>
